import React from "react";
import IMAGES from "../../constant/IMAGES";

const Loading = () => {
  return (
    <div className="bg-bgS1 w-screen h-screen flex items-center justify-center fixed z-[100]">
      <div className="relative ">
        <img src={IMAGES.loadingOutside} alt="" className="" />
        <span className="absolute top-[50%] translate-x-[6%] -translate-y-1/2">
          <img
            src={IMAGES.loadingInside}
            alt=""
            className="animate-rotate w-full h-full"
          />
        </span>
      </div>
    </div>
  );
};

export default Loading;
